import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Map } from 'immutable'
import _ from 'lodash'

import { deleteGroup } from './actions'

import { openPortfolioById } from '../../scenes/Gnosus/scenes/Portfolio/actions'

import { toggleGroupStack } from '../../scenes/Gnosus/components/GroupStack/actions'

function mapStateToProps(state, hocProps) {
    const group =
        state.getIn(['ui', 'entityStack', 'groups', 'groups']).find((g) => _.toString(g.get('id')) === hocProps.id) ||
        Map()
    const activeGroupId = state.getIn(['ui', 'groupStack', 'activeGroup'])

    return {
        isActive: group.get('id').toString() === activeGroupId,
        group,
    }
}

export function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            openPortfolioById,
            toggleGroupStack,
            deleteGroup,
        },
        dispatch
    )
}

export default function (InnerComponent) {
    @connect(mapStateToProps, mapDispatchToProps)
    class HocConnect extends Component {
        render() {
            return <InnerComponent {...this.props} />
        }
    }

    return HocConnect
}
